"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoredPaymentDataBankAccountToJSON = exports.StoredPaymentDataBankAccountFromJSONTyped = exports.StoredPaymentDataBankAccountFromJSON = void 0;
var runtime_1 = require("../runtime");
function StoredPaymentDataBankAccountFromJSON(json) {
    return StoredPaymentDataBankAccountFromJSONTyped(json, false);
}
exports.StoredPaymentDataBankAccountFromJSON = StoredPaymentDataBankAccountFromJSON;
function StoredPaymentDataBankAccountFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'iban': json['iban'],
        'bic': !(0, runtime_1.exists)(json, 'bic') ? undefined : json['bic'],
        'ownerName': !(0, runtime_1.exists)(json, 'ownerName') ? undefined : json['ownerName'],
    };
}
exports.StoredPaymentDataBankAccountFromJSONTyped = StoredPaymentDataBankAccountFromJSONTyped;
function StoredPaymentDataBankAccountToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'iban': value.iban,
        'bic': value.bic,
        'ownerName': value.ownerName,
    };
}
exports.StoredPaymentDataBankAccountToJSON = StoredPaymentDataBankAccountToJSON;
//# sourceMappingURL=StoredPaymentDataBankAccount.js.map